var _defs, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _circle2, _path23, _circle3, _circle4, _path24, _path25, _path26, _rect, _rect2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _circle5, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _polygon, _path66, _path67, _polygon2, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawMarilynV73Y(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 960,
    height: 839.26,
    viewBox: "0 0 960 839.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "1d06f7be-e984-4178-a7a5-7b90ddf36704-42",
    x1: 768.02,
    y1: 857.43,
    x2: 768.02,
    y2: 78.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "marilyn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.07,138.72c-5.14,6.24-7.12,15-9.34,23.27-17.84,66.49-61.78,120-111.83,158.18-21.19,16.18-47,37.89-42.36,66.89,2.49,15.58,13.45,27,21.61,39.74,17.08,26.57,22.61,62.7,14.47,94.5-9.26,36.19-35.12,70-27.11,106.56,4.94,22.56,21.7,38.56,37.82,52.34q37.71,32.23,77.83,60.37c17.93,12.58,37,24.82,57.89,26.41,18.4,1.41,36.42-5.58,53.88-12.49,15.26-6,30.91-12.31,43.23-24.4,8-7.89,14.46-18.08,23.39-24.53,21-15.17,47.94-5.55,72,.91a250.72,250.72,0,0,0,171.6-15.71c82.89-39,146.07-120.75,227.12-164.64,34.86-18.88,72.78-30.59,105.06-54.9a196.26,196.26,0,0,0,46.18-50c24.44-37.65,37.61-85.65,33.82-132.63s-25.17-92.27-58.7-118.79c-35.9-28.39-81.24-33.69-122.1-50.74-42.19-17.61-79.71-47.88-121.49-66.76a248.43,248.43,0,0,0-214.28,4.84c-45.47,22.95-91.55,76.61-142.2,80.64C384.51,140.67,312.25,104.54,284.07,138.72Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.39,
    cy: 797.02,
    rx: 185.38,
    ry: 42.24,
    fill: "#6c63ff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M902,716.81s16.42,32.24,3,49.88,1.22,65.7,1.22,65.7",
    transform: "translate(-120 -30.37)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M906.9,706.78c0,6.22-4.56,11.25-4.56,11.25s-4.56-5-4.56-11.25,4.56-11.25,4.56-11.25S906.9,700.56,906.9,706.78Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M910.55,716.81s-16.42,32.24-3,49.88-1.22,65.7-1.22,65.7",
    transform: "translate(-120 -30.37)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M905.68,706.78c0,6.22,4.56,11.25,4.56,11.25s4.56-5,4.56-11.25-4.56-11.25-4.56-11.25S905.68,700.56,905.68,706.78Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M905.68,706.78c0,6.22,4.56,11.25,4.56,11.25s4.56-5,4.56-11.25-4.56-11.25-4.56-11.25S905.68,700.56,905.68,706.78Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M917.24,716.81s16.42,32.24,3,49.88,1.22,65.7,1.22,65.7",
    transform: "translate(-120 -30.37)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M922.11,706.78c0,6.22-4.56,11.25-4.56,11.25S913,713,913,706.78s4.56-11.25,4.56-11.25S922.11,700.56,922.11,706.78Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M919.55,732.61c-4.31,4.48-11.09,4.95-11.09,4.95s.21-6.79,4.51-11.27,11.09-4.95,11.09-4.95S923.86,728.13,919.55,732.61Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M920,754.85c-4.31,4.48-11.09,4.95-11.09,4.95s.21-6.79,4.51-11.27,11.09-4.95,11.09-4.95S924.29,750.37,920,754.85Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M896.61,767.09c4.07,4.69,3.93,11.49,3.93,11.49s-6.75-.81-10.82-5.51-3.93-11.49-3.93-11.49S892.53,762.4,896.61,767.09Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M900.39,719.66c5.18,3.43,6.86,10,6.86,10s-6.72,1-11.9-2.41-6.86-10-6.86-10S895.21,716.22,900.39,719.66Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M900.39,719.66c5.18,3.43,6.86,10,6.86,10s-6.72,1-11.9-2.41-6.86-10-6.86-10S895.21,716.22,900.39,719.66Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M925.76,716.81s-16.42,32.24-3,49.88-1.22,65.7-1.22,65.7",
    transform: "translate(-120 -30.37)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M920.89,706.78c0,6.22,4.56,11.25,4.56,11.25s4.56-5,4.56-11.25-4.56-11.25-4.56-11.25S920.89,700.56,920.89,706.78Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M920.89,706.78c0,6.22,4.56,11.25,4.56,11.25s4.56-5,4.56-11.25-4.56-11.25-4.56-11.25S920.89,700.56,920.89,706.78Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M922.2,733.09c-4.36,4.43-4.65,11.22-4.65,11.22s6.79-.39,11.15-4.81,4.65-11.22,4.65-11.22S926.57,728.66,922.2,733.09Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M922.2,733.09c-4.36,4.43-4.65,11.22-4.65,11.22s6.79-.39,11.15-4.81,4.65-11.22,4.65-11.22S926.57,728.66,922.2,733.09Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M930.76,763.89c-4.36,4.43-4.65,11.22-4.65,11.22s6.79-.39,11.15-4.81,4.65-11.22,4.65-11.22S935.12,759.46,930.76,763.89Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M918.17,757.12s9.89-15.58,23.76-15.92",
    transform: "translate(-120 -30.37)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M910.47,747.71s-9.89-15.58-23.76-15.92",
    transform: "translate(-120 -30.37)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M909.19,769.95S919.08,754.36,933,754",
    transform: "translate(-120 -30.37)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 821.48,
    cy: 710.71,
    r: 2.57,
    fill: "#6c63ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 766.95,
    cy: 701.51,
    r: 2.57,
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M916.46,775.08s-9.89-15.58-23.76-15.92",
    transform: "translate(-120 -30.37)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 772.94,
    cy: 728.88,
    r: 2.57,
    fill: "#6c63ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 813.14,
    cy: 723.75,
    r: 2.57,
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M971.11,813.68s-23.83-4.77-30.18-11.12S906,785.09,902.81,793,859.92,828,886.93,832.74s63.54,6.35,71.48,3.18S971.11,813.68,971.11,813.68Z",
    transform: "translate(-120 -30.37)",
    fill: "#a8a8a8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M886.93,829.79c27,4.77,63.54,6.35,71.48,3.18,6-2.42,10.25-14,11.91-19.45l.79.17s-4.77,19.06-12.71,22.24-44.48,1.59-71.48-3.18c-7.79-1.38-10-4.61-9.18-8.69C878.41,826.71,881.13,828.76,886.93,829.79Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M966.38,330.17s-11.46-24.23-28.56-32.25c-6.84-3.76-14.66-5-23.07-1.06a23.48,23.48,0,0,0-10,8.32l0,0c-6.87,3.48-16,6.87-25.64,6.87-19.71,0-57.26,23.79-57.26,23.79s-20.65,1.9-22.53,8.57c-.68,2.38-3.26,2.82-6.32,2.39h0c.81-4.23,1.63-7.15,1.63-7.15l7.51-66.62s4.69-15.23-9.39-46.64c-8.31-18.53-24.13-20.83-35.7-19.59l0-.39-1.82-3.32a13.8,13.8,0,0,0,3.37-2.19,6.7,6.7,0,0,1,2.8-1.84,5.7,5.7,0,0,1,2.87.39l8.48,2.68a12.48,12.48,0,0,0,4.47.83c3.6-.22,6.24-3.4,8.43-6.31,1.65-2.2,3.39-4.88,2.55-7.51a27.71,27.71,0,0,0-1.33-2.7c-1.12-2.55-.46-5.56.78-8.05s3-4.68,4.24-7.17a19.39,19.39,0,0,0-2.45-20.53c-1.7-2-3.93-3.88-4.37-6.51-.36-2.15.6-4.28,1.18-6.38a19.26,19.26,0,0,0-3.63-17.08,20.83,20.83,0,0,0-8.93-6.07,11.87,11.87,0,0,0,.71-7c-1.69-7.89-4.16-17.42-10.19-23.12a19.71,19.71,0,0,0-1.84-1.77,13.61,13.61,0,0,0-5.52-3c-4-.93-8.17.86-12.31,1.28-5.7.58-11.31-1.46-17-2.37s-12.25-.33-15.89,4.15c-2.84,3.5-3.17,8.55-5.88,12.16-2.83,3.78-7.69,5.28-12.3,6.08s-9.44,1.14-13.54,3.42a16.67,16.67,0,0,0-8.28,15.35c.15,2.17.72,4.31.61,6.48-.23,4.56-3.35,8.36-6.31,11.8-2.06,2.39-4.24,5.15-4,8.32.23,3.69,3.53,6.32,5.18,9.62,2.55,5.11.9,11.32-1.49,16.51s-5.53,10.25-6,16a35,35,0,0,0,.81,8.65c.46,2.57,1.22,5.5,3.14,7a4.86,4.86,0,0,0,2.3,1.7,18.36,18.36,0,0,1,2.2.66,4.63,4.63,0,0,1,.25,2c0,.49,0,1,0,1.48l-1.43.13c-16.9,1.9-36.61,11.42-35.67,22.84s3.75,39,3.75,39,8.45,50.44,21.59,69.48a148.07,148.07,0,0,1,19.86,41.25l7.83,25.88.45,1.48c-4,4.28-7.31,9.11-8.43,14.2-3.75,17.13-40.36,25.7-40.36,25.7s-38,18.44-40.38,44.31l-1.73,6.13L585.29,531s-21.59,19-15,33.31,27.22,18.08,26.28,32.36c-.13,2,.71,2.93,2.26,3,3.81,6.08,34.26-18.48,43.74-26.35-2.72,10.25-9.53,41.18,5.32,47.17a14.82,14.82,0,0,0,9.34,1.88c.05,2.4.16,4.92.36,7.59l-14.08,62.82s-6.79,49.7-14.28,66.86l-.42,0a15.48,15.48,0,0,1-2.2,3.6,23.75,23.75,0,0,0-3.64,7l.35,0c-.12.3-.24.6-.35.91-5.1,13.65-9.43,40.54-11.31,53.39l-.27,1.84-1.68-.38s-.33,6.09-9.55,8.28l0,.23c-3.91.63-7.82,2.81-6.48,9.27l-7.45.3v4.76l44.12-1,28.16-38.07-1.88,31.41h6.57l4.69-33.31s20.65-17.13.94-34.26h-1.69a11,11,0,0,0-1.12-1.9c-1-1.43-1.51-3.72-1.56-6.5,0-.74,0-1.5.09-2.3.86-12.31,7.11-30.23,7.11-30.23l23.47-48.54s14.08-16.18,9.39-59c0,0,25.34-45.68,46-60.91a35.91,35.91,0,0,0,3.34-2.85l3.23,31.41,1.7-.78.18,1.73s24.22-11.26,45.88-19.48l3.87,26.14s9.39,27.6,7.51,45.68,0,68.53,0,68.53,5.63,45.68,0,57.11l-.06.13h-.42a51,51,0,0,0-2.07,6.72h.24l-.24.94c-3.78,15-7.14,43-8.3,53.13l-.11,1h-2.19s-5.63,17.13,0,21.89,34.73-1,34.73-1,11.79-13.81,2.35-20.6V795.57s-.44-5.91-.62-13.67c-.06-2.35-.09-4.87-.08-7.45,0-10.47.78-21.84,3.52-26.47,5.63-9.52,16.9-57.11,16.9-66.62S857,627.11,857,627.11s-8.45-39,2.82-61.86l8-37.4c6.44-11.29,11.2-20.66,11.2-20.66s47.87-64.72,70.4-67.57S966.38,330.17,966.38,330.17ZM633.88,831.48l-1.51-.34c.23-.55.48-1.13.75-1.74,4-9.08,12.64-24.53,27-32.19ZM708.25,393s-.91.46-2.4,1.3l-1.23-2.83-.73-1.88-.19-.5-.52-1.37-.18-.48-.61-1.64-.2-.55-.41-1.12-.23-.63-.43-1.21-.25-.71-.37-1.08-.21-.62-.29-.9-.18-.55-.39-1.25-.15-.5-.23-.81-.14-.49q-.14-.5-.26-1l-.09-.35q-.11-.46-.21-.89l-.08-.36q-.08-.37-.14-.72l0-.26q-.08-.45-.12-.85c0-.07,0-.13,0-.19s0-.4,0-.59,0-.14,0-.2a5.51,5.51,0,0,1,0-.62,7.58,7.58,0,0,0,0-.78s0-.08,0-.12c0-.28,0-.59-.05-.92v-.12A76.52,76.52,0,0,0,695.14,355l.91.86S712,373.95,708.25,393Z",
    transform: "translate(-120 -30.37)",
    fill: "url(#1d06f7be-e984-4178-a7a5-7b90ddf36704-42)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 570.11,
    y: 112.76,
    width: 56.32,
    height: 76.97,
    fill: "#ffcd50"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 570.11,
    y: 112.76,
    width: 56.32,
    height: 76.97,
    opacity: 0.05
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M782.8,126.67a18.8,18.8,0,0,1,3.63,16.85c-.58,2.08-1.54,4.17-1.18,6.29.44,2.59,2.67,4.42,4.37,6.42a18.91,18.91,0,0,1,2.45,20.25c-1.23,2.46-3,4.62-4.24,7.07s-1.91,5.43-.78,7.94a27.18,27.18,0,0,1,1.33,2.66c.83,2.59-.91,5.24-2.55,7.41-2.18,2.87-4.82,6-8.43,6.22a12.64,12.64,0,0,1-4.47-.82l-8.48-2.65a5.77,5.77,0,0,0-2.87-.38,6.71,6.71,0,0,0-2.8,1.82c-2.91,2.53-7.29,4.2-10.58,2.18s-3.77-6.67-3.73-10.6c.05-4.48.38-9.32,3.26-12.76,1.83-2.19,4.51-3.53,6.35-5.72,3.95-4.7,3-11.61,2.86-17.75a12.16,12.16,0,0,1,.47-4.12,14.1,14.1,0,0,1,1.88-3.33c3.44-5,6.79-10.16,8.61-15.94,1.91-6,1.38-11.51-.56-17.4C772.6,118.78,779.5,122.73,782.8,126.67Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffcd50"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M754.41,207.42l-10.18,15.27-1.08,1.62-.61,2.33-9.71,37.09v56.32l-23.47,30-24.4-42.24s-21.59-31,5.63-77.91a171.1,171.1,0,0,0,8.26-16.08c.52-1.15,1-2.29,1.47-3.42,6-14.34,8.29-26.25,8.9-35.31.89-13.12-1.74-20.28-1.74-20.28l49.75,12.2a160.21,160.21,0,0,0-4.91,15.59C746.41,206.09,754.41,207.42,754.41,207.42Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd5d8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M743.14,214.93s35.67-15,49.75,16,9.39,46,9.39,46l-7.51,65.7s-5.63,19.71-1.88,31,10.32,59.13,10.32,59.13l-35.67,4.69s-1.88-44.12-7.51-56.32l1.72-72.28a30.93,30.93,0,0,0-2.37-12.63h0a211.19,211.19,0,0,1-16.25-81.23Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd5d8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M694.81,222.24a38.56,38.56,0,0,0-27.7-7.31c-16.9,1.88-36.61,11.26-35.67,22.53s3.75,38.48,3.75,38.48,8.45,49.75,21.59,68.52l13.14,18.77,25.34,82.6,31-3.75s-29.1-61-28.16-70.4-19.71-61.95-19.71-61.95Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd5d8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M726.25,442.08l-31,3.75-10.79-35.17-7.83-25.52a145.18,145.18,0,0,0-19.86-40.68h0c-13.14-18.77-21.59-68.52-21.59-68.52s-2.82-27.22-3.75-38.48,18.77-20.65,35.67-22.53a40,40,0,0,1,15.07,1.16,35.64,35.64,0,0,1,12.62,6.15l-16.44,87.49s12.83,32.67,17.81,51.1c1.33,4.95,2.1,8.86,1.91,10.85-.33,3.29,3,12.87,7.5,24C713.93,416.27,726.25,442.08,726.25,442.08Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd5d8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M598.59,492.77l-11.26,39.42S565.74,551,572.31,565s27.22,17.83,26.28,31.91,46.93-26.28,46.93-26.28-16.9,53.5,12.2,50.69,53.5-61,53.5-61l43.18-12.2,4.69,45.05s67.58-31,77.91-27.22,42.24-58.2,42.24-58.2,47.87-63.83,70.4-66.64,16.9-107.94,16.9-107.94-21.59-45.05-49.75-31.91S914,350.1,914,350.1l-85.42,69.46-89.17,17.83Z",
    transform: "translate(-120 -30.37)",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M947.76,440.2c-22.53,2.82-70.4,66.64-70.4,66.64S845.45,568.8,835.13,565s-77.91,27.22-77.91,27.22l-4.69-45.05-43.18,12.2s-24.4,58.2-53.5,61-12.2-50.69-12.2-50.69S595.78,610.1,596.71,596,577,578.18,570.43,564.1s15-32.85,15-32.85l8.58-30,2.68-9.39,140.79-55.38,89.17-17.83,85.42-69.46s-17.58-24.74-7.19-40.61a23.4,23.4,0,0,1,10-8.2c28.16-13.14,49.75,31.91,49.75,31.91S970.29,437.39,947.76,440.2Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.02
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M820.11,462.73s-5.21,9.21-12.93,22.14c-2.11,3.52-4.41,7.33-6.83,11.29L798.59,499c-15.75,25.54-36.31,56.63-47.94,65.08-20.65,15-46,60.07-46,60.07,4.69,42.24-9.39,58.2-9.39,58.2l-23.47,47.87s-6.24,17.67-7.11,29.81c-.3,4.18,0,7.69,1.47,9.61a11.49,11.49,0,0,1,1.8,3.64c2.31,7.68-1.8,17.95-1.8,17.95-17.93,6-28.34,24.16-32.9,34.3a69.62,69.62,0,0,0-2.77,7l-19.71-4.69s.36-2.72,1-7.08c1.88-12.67,6.21-39.2,11.31-52.66a23.32,23.32,0,0,1,3.64-6.91,15.23,15.23,0,0,0,2.2-3.55c7.66-16,14.7-66.85,14.7-66.85l14.08-61.95c-2.82-37.55,10.32-46.93,10.32-46.93l32.49-68,7.88-16.48,95.75-29.77,2.52-.78Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd5d8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M607,830.68s-16-2.82-13.14,9.39H607Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd5d8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M633.27,825.55a69.62,69.62,0,0,0-2.77,7l-19.71-4.69s.36-2.72,1-7.08Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.05
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M635.2,827.86l-25.34-5.63s-.33,6-9.55,8.17l1.11,11.54,26.28-.94Z",
    transform: "translate(-120 -30.37)",
    fill: "#4f4a55"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M586.39,840.06v4.69l44.12-.94,28.16-37.55-1.88,31h6.57l4.69-32.85s20.65-16.9.94-33.79h-6.57l-.94,21.59-29.1,37.55-22.53,9.39Z",
    transform: "translate(-120 -30.37)",
    fill: "#4f4a55"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M668,772.37l-44.87-5.18a23.32,23.32,0,0,1,3.64-6.91,15.23,15.23,0,0,0,2.2-3.55l35.75,2.38c-.3,4.18,0,7.69,1.47,9.61A11.49,11.49,0,0,1,668,772.37Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.05
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M668,773.31l-44.87-5.18a23.32,23.32,0,0,1,3.64-6.91,15.23,15.23,0,0,0,2.2-3.55l35.75,2.38c-.3,4.18,0,7.69,1.47,9.61A11.49,11.49,0,0,1,668,773.31Z",
    transform: "translate(-120 -30.37)",
    fill: "#4f4a55"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M820.11,462.73s-5.21,9.21-12.93,22.14c-2.11,3.52-4.41,7.33-6.83,11.29L798.59,499l-.12-2.85-.29-6.78-.59-13.52s2.47-3.17,6.58-8.18l2.52-.78Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M882.62,433.15c0,26-7.13,57.74-7.13,57.74l-16,73.21c-11.26,22.53-2.82,61-2.82,61s2.82,44.12,2.82,53.5-11.26,56.32-16.9,65.7c-2.74,4.56-3.48,15.78-3.52,26.1,0,2.54,0,5,.08,7.35.18,7.65.62,13.48.62,13.48v44.12l-34.73-2.82s.15-1.39.42-3.75c1.15-10,4.51-37.55,8.3-52.39a49.78,49.78,0,0,1,2.07-6.63c.16-.38.32-.73.48-1.05,5.63-11.26,0-56.32,0-56.32s-1.88-49.75,0-67.58-7.51-45.05-7.51-45.05l-5.63-37.55-2.87-66.06-.29-6.78-.59-13.52s2.73-3.5,7.22-9c4.68-5.72,11.28-13.57,18.61-21.77,7.54-8.41,15.84-17.17,23.68-24.32,14.12-12.9,26.68-20.58,30.27-11.59C881.7,415.38,882.61,423.9,882.62,433.15Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd5d8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M839.82,828.8v6.57l-34.73-2.82s.15-1.39.42-3.75Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M818.23,829.74h-15s-5.63,16.9,0,21.59,34.73-.94,34.73-.94,12.2-14.08,1.88-20.65Z",
    transform: "translate(-120 -30.37)",
    fill: "#4f4a55"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M757.22,167.06a160.21,160.21,0,0,0-4.91,15.59,40.41,40.41,0,0,1-43.1-7.51c.89-13.12-1.74-20.28-1.74-20.28Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 616.57,
    cy: 113.23,
    r: 40.36,
    fill: "#ffd5d8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M757,211.59a55.68,55.68,0,0,0-13.26,3.13l8.83-12Z",
    transform: "translate(-120 -30.37)",
    fill: "#f0f0f2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M879.71,410.17a5.65,5.65,0,0,0-6.47-3.84,5.53,5.53,0,0,1,4.59,3.84c2.46,6.15,3.37,14.67,3.38,23.92,0,26-7.13,57.74-7.13,57.74l-16,73.21c-11.26,22.53-2.82,61-2.82,61s2.82,44.12,2.82,53.5-11.26,56.32-16.9,65.7c-2.74,4.56-3.48,15.78-3.52,26.1,0,2.54,0,5,.08,7.35.18,7.65.62,13.48.62,13.48v44l1.88.15V792.19s-.44-5.83-.62-13.48c-.06-2.32-.09-4.81-.08-7.35,0-10.32.78-21.54,3.52-26.1,5.63-9.39,16.9-56.32,16.9-65.7s-2.82-53.5-2.82-53.5-8.45-38.48,2.82-61l16-73.21s7.16-31.71,7.13-57.74C883.08,424.84,882.17,416.32,879.71,410.17Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M848.27,459a99.66,99.66,0,0,0-30,17.83,131.66,131.66,0,0,1-11.06,8.06c-2.09,1.39-4.48,2.91-7.12,4.51a225.8,225.8,0,0,1-62.54,25.91c-15.87,3.9-27.92,2.43-37-1.35l7.88-16.48,98.27-30.55c4.68-5.72,11.28-13.57,18.61-21.77,7.54-8.41,15.84-17.17,23.68-24.32l8.68-4.08S866.1,452.41,848.27,459Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.05
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M882.62,433.15c-17.67-.12-41.39,6.65-57.33,12,21.12-23.57,48.36-49.89,54-35.91C881.7,415.38,882.61,423.9,882.62,433.15Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.05
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M675.56,485.26s12.2,40.36,61.95,28.16,80.72-38.48,80.72-38.48a99.66,99.66,0,0,1,30-17.83c17.83-6.57,9.39-42.24,9.39-42.24l-47.87,22.53-31.91-22.53-27.22,9.39-75.09,21.59Z",
    transform: "translate(-120 -30.37)",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M677,485.26s12.2,40.36,61.95,28.16,80.72-38.48,80.72-38.48a99.66,99.66,0,0,1,30-17.83c17.83-6.57,9.39-42.24,9.39-42.24l-47.87,22.53-31.91-22.53-27.22,9.39L677,445.84Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.02
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M926.17,367s-5.63,75.09-31.91,67.58-86.35,16.9-86.35,16.9-4.69-8.45-19.71-12.2-31,13.14-31,13.14-24.4-3.75-47.87-.94-11.26,31-11.26,31-16.9,20.65-42.24,14.08-37.55,5.63-37.55,5.63h-22.4l2.68-9.39,140.79-55.38,89.17-17.83L914,350.1s-17.58-24.74-7.19-40.61a73.43,73.43,0,0,0,10-6.33s16.9,21.59,28.16,28.16S926.17,367,926.17,367Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.03
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M744.22,222.69l-1.08,1.62-10.32,39.42v56.32l-23.47,30-24.4-42.24s-21.59-31,5.63-77.91a166.47,166.47,0,0,0,9.73-19.5l.59-.22s-4.69,87.29-3.75,101.37,18.77,22.53,18.77,22.53c-4.69-19.71,11.26-95.74,11.26-95.74l16.9-22.93c0,.8,0,1.61,0,2.41s0,1.35,0,2a2.28,2.28,0,0,0,0,.25C744.16,221,744.19,221.85,744.22,222.69Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M742.53,226.65l-9.71,37.09v56.32l-23.47,30-24.4-42.24s-21.59-31,5.63-77.91a171.1,171.1,0,0,0,8.26-16.08c-.87,16.64-4.39,85.39-3.57,97.74.94,14.08,18.77,22.53,18.77,22.53-4.69-19.71,11.26-95.74,11.26-95.74l16.9-22.93c0,.8,0,1.61,0,2.41s0,1.35,0,2a2.28,2.28,0,0,0,0,.25c0,2,.13,4,.23,6C742.51,226.31,742.51,226.48,742.53,226.65Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M669,310.67v-8.19a220.66,220.66,0,0,1,7.2-55.9l3.13-11.94.94-17.83,1.93-.71a35.64,35.64,0,0,1,12.62,6.15l-16.44,87.49s12.83,32.67,17.81,51.1c-1.12-1.47-1.85-2.29-1.85-2.29C659.6,326.63,669,310.67,669,310.67Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M726.25,442.08l-31,3.75-10.79-35.17c7.9-7.71,18-13.37,21.11-15C713.93,416.27,726.25,442.08,726.25,442.08Z",
    transform: "translate(-120 -30.37)",
    fill: "#f0f0f2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M926.17,365.11s-5.63,75.09-31.91,67.58-86.35,16.9-86.35,16.9-4.69-8.45-19.71-12.2-31,13.14-31,13.14-24.4-3.75-47.87-.94-11.26,31-11.26,31-16.9,20.65-42.24,14.08-37.55,5.63-37.55,5.63H595.78c-2.82-28.16,40.36-48.81,40.36-48.81s36.61-8.45,40.36-25.34,31.91-31,31.91-31c3.75-18.77-12.2-36.61-12.2-36.61-34.73-31.91-25.34-47.87-25.34-47.87v-8.19a220.66,220.66,0,0,1,7.2-55.9l3.13-11.94.94-17.83L700,210.24s-4.69,87.29-3.75,101.37S715,334.14,715,334.14c-4.69-19.71,11.26-95.74,11.26-95.74l16.9-22.93c0,.8,0,1.61,0,2.41s0,1.35,0,2a2.28,2.28,0,0,0,0,.25c0,2,.13,4,.23,6,0,.23,0,.45,0,.69,0,.79.09,1.58.15,2.37,0,.47.06.93.09,1.39,0,.06,0,.11,0,.17q.11,1.51.25,3a.35.35,0,0,0,0,.09c.08,1,.18,2,.28,2.92l.11,1.07c.11,1.08.23,2.15.38,3.22s.26,2.1.41,3.15c0,.16,0,.31.07.47.15,1.38.36,2.71.61,4l0,.14a50.4,50.4,0,0,0,6.65,16.8l28.16,79.78s7,3.48,12.45,4.23h0c3.06.42,5.64,0,6.32-2.36,1.88-6.57,22.53-8.45,22.53-8.45s37.55-23.47,57.26-23.47,37.55-14.08,37.55-14.08,16.9,21.59,28.16,28.16S926.17,365.11,926.17,365.11Z",
    transform: "translate(-120 -30.37)",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M709.82,386.23s20.65-1.88,35.67-4.69,47.87-31,47.87-31",
    transform: "translate(-120 -30.37)",
    opacity: 0.02
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M835.13,843.82H803.21a17.23,17.23,0,0,1,1.38-1.41c3.81-3.55,15.13-11.74,29,0C834.08,842.84,834.6,843.32,835.13,843.82Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd5d8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M839.2,776.84l-25.39-1.37a49.78,49.78,0,0,1,2.07-6.63l23.24.65C839.11,772,839.14,774.52,839.2,776.84Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M839.2,777.77l-25.39-1.37a49.78,49.78,0,0,1,2.07-6.63l23.24.65C839.11,773,839.14,775.46,839.2,777.77Z",
    transform: "translate(-120 -30.37)",
    fill: "#4f4a55"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M763.48,90.18A13.68,13.68,0,0,0,758,87.25c-4-.92-8.17.84-12.31,1.26-5.7.57-11.31-1.44-17-2.34s-12.25-.33-15.89,4.1c-2.84,3.45-3.17,8.43-5.88,12-2.83,3.72-7.69,5.21-12.3,6s-9.44,1.12-13.54,3.37a16.39,16.39,0,0,0-8.28,15.14c.15,2.14.72,4.25.61,6.39-.23,4.49-3.35,8.24-6.31,11.63-2.06,2.36-4.24,5.08-4,8.21.23,3.64,3.53,6.24,5.18,9.49,2.55,5,.9,11.17-1.49,16.29s-5.53,10.11-6,15.75a34.06,34.06,0,0,0,.81,8.53c.55,3.06,1.55,6.66,4.5,7.65,1,.34,2.26.36,2.93,1.2a3.59,3.59,0,0,1,.46,2.39c-.19,6,1.27,12.72,6.17,16.25a15.6,15.6,0,0,0,4.66,2.19,19.07,19.07,0,0,0,15.09-1.48c4.47-2.66,7.51-7.84,7-13-.22-2.26-1.07-4.42-1.42-6.67s-.07-4.8,1.58-6.36a20.8,20.8,0,0,1,3.14-2c3.92-2.57,5-8,4.2-12.6s-3.1-8.83-4.59-13.27c-1.93-5.74-2.51-11.83-3-17.86-.4-4.88-.75-9.83.14-14.64a6.39,6.39,0,0,1,1-2.68,6.22,6.22,0,0,1,3.06-1.93c5.34-1.87,11.18-1.66,16.72-2.83s11.34-4.41,12.67-9.91c1-4.33-.7-9.71,2.5-12.82,2.78-2.7,7.4-1.64,10.91,0a50.9,50.9,0,0,1,10.31,6.4c3.29,2.63,7.72,6.19,11.79,2.93,2.91-2.33,3.91-6.74,3.16-10.2C772.8,105.62,770.17,95.66,763.48,90.18Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M762.54,89.24A13.68,13.68,0,0,0,757,86.31c-4-.92-8.17.84-12.31,1.26-5.7.57-11.31-1.44-17-2.34s-12.25-.33-15.89,4.1c-2.84,3.45-3.17,8.43-5.88,12-2.83,3.72-7.69,5.21-12.3,6s-9.44,1.12-13.54,3.37a16.39,16.39,0,0,0-8.28,15.14c.15,2.14.72,4.25.61,6.39-.23,4.49-3.35,8.24-6.31,11.63-2.06,2.36-4.24,5.08-4,8.21.23,3.64,3.53,6.24,5.18,9.49,2.55,5,.9,11.17-1.49,16.29s-5.53,10.11-6,15.75a34.06,34.06,0,0,0,.81,8.53c.55,3.06,1.55,6.66,4.5,7.65,1,.34,2.26.36,2.93,1.2a3.59,3.59,0,0,1,.46,2.39c-.19,6,1.27,12.72,6.17,16.25a15.6,15.6,0,0,0,4.66,2.19,19.07,19.07,0,0,0,15.09-1.48c4.47-2.66,7.51-7.84,7-13-.22-2.26-1.07-4.42-1.42-6.67s-.07-4.8,1.58-6.36a20.8,20.8,0,0,1,3.14-2c3.92-2.57,5-8,4.2-12.6s-3.1-8.83-4.59-13.27c-1.93-5.74-2.51-11.83-3-17.86-.4-4.88-.75-9.83.14-14.64a6.39,6.39,0,0,1,1-2.68,6.22,6.22,0,0,1,3.06-1.93c5.34-1.87,11.18-1.66,16.72-2.83S733.62,132,735,126.52c1-4.33-.7-9.71,2.5-12.82,2.78-2.7,7.4-1.64,10.91,0a50.9,50.9,0,0,1,10.31,6.4c3.29,2.63,7.72,6.19,11.79,2.93,2.91-2.33,3.91-6.74,3.16-10.2C771.86,104.68,769.23,94.72,762.54,89.24Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffcd50"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M743.21,220.16c0,2,.13,4,.23,6C743.33,224.15,743.25,222.15,743.21,220.16Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd5d8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M803.21,432.7l-35.67,4.69s-1.88-44.12-7.51-56.32l1.72-72.27a31,31,0,0,0-2.37-12.63c-5.36-12.87-6.86-30.54-6.86-30.54l28.16,79.78s7,3.48,12.45,4.23c-1.3,6.77-2.56,17-.24,23.93C796.64,384.83,803.21,432.7,803.21,432.7Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd5d8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "632.53 172.36 606.25 208.03 632.53 234.31 637.22 180.81 632.53 172.36",
    fill: "#fff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M747.37,433.16s24.4-18.77,42.71-10.79,37.08,1.41,37.08,1.41L819.64,436,769,437.86Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.05
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M747.37,434.1s24.4-18.77,42.71-10.79,37.08,1.41,37.08,1.41l-7.51,12.2L769,438.8Z",
    transform: "translate(-120 -30.37)",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "562.84 374.96 575.74 415.93 604.03 407.02 584.78 363.26 562.84 374.96",
    fill: "#ffd5d8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M684.48,445.37s13.14-19.71,21.59-16.9,27.61-.28,27.61-.28l-4.15,14.36-21.59,2.82-19.71,6.57Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.05
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M684.48,446.31s13.14-19.71,21.59-16.9,27.61-.28,27.61-.28l-4.15,14.36-21.59,2.82-19.71,6.57Z",
    transform: "translate(-120 -30.37)",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M859.3,416.13s27,5.77,43.88-12.06,11.26-33.79,20.65-43.18,18.77-17.83,16.9-25.34",
    transform: "translate(-120 -30.37)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.05
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M835.13,843.82H803.21a17.23,17.23,0,0,1,1.38-1.41h29C834.08,842.84,834.6,843.32,835.13,843.82Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M410.59,277.56c-12.79,6.69-18.25,21.51-18.25,21.51s15.28,4,28.07-2.73,18.25-21.51,18.25-21.51S423.38,270.87,410.59,277.56Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff",
    opacity: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M504.2,460.5c-10.13,10.28-10.8,26.06-10.8,26.06s15.76-.9,25.89-11.18,10.8-26.06,10.8-26.06S514.33,450.21,504.2,460.5Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff",
    opacity: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M425.77,526c-14.29,2-24.38,14.19-24.38,14.19s13.08,8.84,27.37,6.79,24.38-14.19,24.38-14.19S440.06,523.92,425.77,526Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff",
    opacity: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M544.56,97.24c-10.13,10.28-10.8,26.06-10.8,26.06s15.76-.9,25.89-11.18,10.8-26.06,10.8-26.06S554.69,87,544.56,97.24Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff",
    opacity: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M846.8,174.21c-10.13,10.28-10.8,26.06-10.8,26.06s15.76-.9,25.89-11.18S872.69,163,872.69,163,856.93,163.93,846.8,174.21Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff",
    opacity: 0.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1,457.68c-10.13,10.28-10.8,26.06-10.8,26.06s15.76-.9,25.89-11.18S348,446.5,348,446.5,332.24,447.4,322.1,457.68Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff",
    opacity: 0.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M255.78,317.58c-12.79,6.69-18.25,21.51-18.25,21.51s15.28,4,28.07-2.73,18.25-21.51,18.25-21.51S268.58,310.88,255.78,317.58Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff",
    opacity: 0.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M566.47,326c-12.79,6.69-18.25,21.51-18.25,21.51s15.28,4,28.07-2.73,18.25-21.51,18.25-21.51S579.26,319.33,566.47,326Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff",
    opacity: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M290.19,688.49s7.87,10.29-3.63,25.82-21,28.64-17.14,38.32c0,0,17.35-28.84,31.46-29.25S305.72,705.84,290.19,688.49Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M290.19,688.49a12.74,12.74,0,0,1,1.61,3.23c13.78,16.18,21.11,31.29,7.87,31.67-12.33.35-27.13,22.41-30.67,28a12,12,0,0,0,.42,1.27s17.35-28.84,31.46-29.25S305.72,705.84,290.19,688.49Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M304.81,701.6c0,3.62-.41,6.55-.91,6.55s-.91-2.93-.91-6.55.51-1.92,1-1.92S304.81,698,304.81,701.6Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd037"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M309.83,705.92c-3.18,1.73-6,2.78-6.19,2.34s2.14-2.2,5.32-3.93,1.93-.47,2.17,0S313,704.19,309.83,705.92Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd037"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M248.64,688.49s-7.87,10.29,3.63,25.82,21,28.64,17.14,38.32c0,0-17.35-28.84-31.46-29.25S233.11,705.84,248.64,688.49Z",
    transform: "translate(-120 -30.37)",
    fill: "#6c63ff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M248.64,688.49a12.74,12.74,0,0,0-1.61,3.23c-13.78,16.18-21.11,31.29-7.87,31.67,12.33.35,27.13,22.41,30.67,28a12,12,0,0,1-.42,1.27s-17.35-28.84-31.46-29.25S233.11,705.84,248.64,688.49Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.1
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M234,701.6c0,3.62.41,6.55.91,6.55s.91-2.93.91-6.55-.51-1.92-1-1.92S234,698,234,701.6Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd037"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M229,705.92c3.18,1.73,6,2.78,6.19,2.34s-2.14-2.2-5.32-3.93-1.93-.47-2.17,0S225.82,704.19,229,705.92Z",
    transform: "translate(-120 -30.37)",
    fill: "#ffd037"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M236.52,751.28s22-.68,28.62-5.4,33.83-10.36,35.47-2.79,33.05,37.65,8.22,37.85-57.69-3.87-64.31-7.9S236.52,751.28,236.52,751.28Z",
    transform: "translate(-120 -30.37)",
    fill: "#a8a8a8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M309.28,778.31c-24.83.2-57.69-3.87-64.31-7.9-5-3.07-7-14.08-7.72-19.16l-.73,0s1.39,17.74,8,21.77,39.48,8.1,64.31,7.9c7.17-.06,9.64-2.61,9.51-6.38C317.35,776.84,314.61,778.27,309.28,778.31Z",
    transform: "translate(-120 -30.37)",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawMarilynV73Y);
export default __webpack_public_path__ + "static/media/undraw_marilyn_v-73-y.ff477072ddd1a814921fdf74aa96b5af.svg";
export { ForwardRef as ReactComponent };